<template>
    <div class="bottom f-flex" v-if="!userAgent">
        <div style="width:80%;margin:0 auto;position: relative;">
            <div class="t-left">
                <p>联系我们</p>
                <p>请填写您的需求我们会尽快给您回复</p>
                <div class="f-flex">
                    <input v-model="name" type="text" placeholder="您的姓名：">
                    <input v-model="phone" type="text" placeholder="联系电话：">
                    <input v-model="email" type="text" placeholder="联系邮箱：">
                </div>
                <textarea v-model="info" name="" id="" cols="30" rows="10"></textarea><br>
                <button @click="handSubmit">提交留言</button>
            </div>
            <div class="t-right ">
                <div class="t-info">
                    <img width="5%" height="5%" src="@/assets/images/pos1.png" alt="">
                    <div>
                        <p>地址</p>
                        <p>上海市杨浦区国权路14-16号 </p>
                    </div>          
                </div>
                <div class="t-info">
                    <img width="5%" height="5%" src="@/assets/images/dianhua.png" alt="">
                    <div>
                        <p>电话</p>
                        <p>400-878-2977</p>
                    </div>
                </div>
                <div class="t-info">
                    <img width="5%" height="5%" src="@/assets/images/shouji.png" alt="">  
                    <div>
                        <p>手机</p>
                        <p>13917715707 </p>
                    </div>            
                </div>
                <div class="t-info">
                    <img width="5%" height="5%" src="@/assets/images/email.png" alt="">
                    <div>
                        <p>邮箱</p>
                        <p>service@mixietai.cn</p>
                    </div>
                
                </div>
                
            </div>
        </div>
            
        
    </div>
    <div class="bottom1" v-else>
        <div style="width:90%;margin:0 auto">
            <div class="t-left1">
            <p>联系我们</p>
            <p>请填写您的需求我们会尽快给您回复</p>
            <input v-model="name" type="text" placeholder="您的姓名：">
            <input v-model="phone" type="text" placeholder="联系电话：">
            <input v-model="email" type="text" placeholder="联系邮箱：">
            <textarea v-model="info" name="" id="" cols="30" rows="10"></textarea><br>          
            <div>
                <button @click="handSubmit">提交留言</button>
            </div>
        </div>
        <div class="t-right1">
            <div class="t-info1">
                <img width="5%" height="5%" src="@/assets/images/pos1.png" alt="">
                <div>
                    <p>地址</p>
                    <p>上海市杨浦区国权路14-16号</p>
                </div>          
            </div>
            <div class="t-info1">
                <img width="5%" height="5%" src="@/assets/images/dianhua.png" alt="">
                <div>
                    <p>电话</p>
                    <p>400-878-2977</p>
                </div>
            </div>
            <div class="t-info1">
                <img width="5%" height="5%" src="@/assets/images/shouji.png" alt="">  
                <div>
                    <p>手机</p>
                    <p>13917715707 </p>
                </div>            
            </div>
            <div class="t-info1">
                <img width="5%" height="5%" src="@/assets/images/email.png" alt="">
                <div>
                    <p>邮箱</p>
                    <p>service@mixietai.cn</p>
                </div>
               
            </div>
            
        </div>
        </div>
        
    </div>
</template>

<script>
export default {
    name:'ContcatItem',
    data(){
        return{
            name:"",
            phone:"",
            email:"",
            info:"",
        }
    },
    mounted(){
        
    },
    methods: {
        // 用户信息提交
        handSubmit(){
            if(this.name && this.phone && this.email && this.info){
                this.$http({
                    url:'api/index/sendmessage',
                    method:'post',
                    data:{
                        name:this.name,
                        mobile:this.phone,
                        email:this.email,
                        msg:this.info
                    }
                }).then(res=>{                   
                    if(res.data.code==1){
                        this.$message({
                            message:res.data.msg,
                            type:"success",          
                            })
                    }
                })
                this.name="",
                this.phone="",
                this.email="",
                this.info=""
            }else{
                this.$message({
                    message:"内容不能为空",
                    duration:1000,
                    type:"warning"
                })
            }         
        }
    },
}
</script>

<style scoped>
/* pc端 */
.bottom{
    background-color:black;
    overflow: hidden;
    width: 100%;
    position: relative;
}
.t-left{
    width: 45%;
    max-width: 680px;
    text-align: center;
}
.t-left p:nth-child(1){
    font-weight: bold;
    color: white;
    font-size: 28px;
    margin-top: 30px;
    text-align: left;
}
.t-left p:nth-child(2){
    font-weight: bold;
    text-align: left;
    color: white;
    margin: 20px 0;
    font-size: 8px;
}
.t-left div{
    width: 90%;
    margin-left: 10px;
    justify-content: space-between;
}
.t-left input::-webkit-input-placeholder{
    color: #8D8D8D;
    font-weight: bold;
}
.t-left>div input{
    width:27%;
    padding:12px 15px;
    font-size: 10px;
    border-radius: 5px;
    margin-bottom: 20px;
    outline: none;
}
.t-left button{
    background-color:#BD101C;
    color: white;
    text-align: center;
    border: none;
    font-size: 18px;
    padding: 10px;
    margin-top: 10px;
    outline: none;
}
.t-left textarea{
    margin-left: -40px;
    width:90%;
    height: 40%;
    outline: none;
    border-radius: 5px;
}

.t-right{
    color: white;
    font-weight: bold;
    font-size: 18px;
    width: 40%;
    position: absolute;
    top: 25px;
    right: 10px;
}
.t-info{
    border-bottom: 1px solid #fff;
    align-items: center;
    display: flex;
}
.t-info img{
    width:30px;
}
.t-info div p{
    margin: 8% 0;
    margin-left: 10px;
}
/* 移动端 */
.t-left1{
    width: 100%;
}
.t-left1 p:nth-child(1){
    font-weight: bold;
    color: white;
    font-size: 18px;
    margin-top: 30px;
    text-align: left;
}
.t-left1 p:nth-child(2){
    font-weight: bold;
    text-align: left;
    color: white;
    margin: 10px 0;
    font-size: 10px;
    margin: 5% 0;
}
.t-left1 div{
    width: 90%;
    margin-left: 10px;
    justify-content: space-between;
}
.t-left1 input::-webkit-input-placeholder{
    color: #8D8D8D;
    font-weight: bold;
}
.t-left1 input{
    display: block;
    width:90%;
    padding:10px;
    font-size: 8px;
    border-radius: 5px;
    margin-bottom: 10px;
    outline: none;
}
.t-left1 textarea{
    width:95%;
    height: 85px;
    outline: none;
    border-radius: 5px;
}
.t-left1>div{
    width: 40%;
    margin: 0 auto;
    text-align: center;
}
.t-left1 button{
    background-color:#BD101C;
    color: white;
    text-align: center;
    border: none;
    font-size: 10px;
    font-weight: 800px;
    margin-top: 10px;
    padding: 5px;
}
.t-right1{
    color: white;
    font-weight: bold;
    width: 90%;
    margin-left: 10px;
}
.t-info1{
    border-bottom: 1px solid #fff;
    align-items: center;
    padding: 3% 0;
    display: flex;
}
.t-info1 img{
    width:22px;
}
.t-info1 div p{
    margin-left: 4px;
    font-size: 11px;
    margin-top: 10px;
}
.bottom1{
    background-color:black;
    overflow: hidden;
    width: 100%;
}

</style>